import React, { useState, useEffect, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import useFirebase from "../../../../../useFirebase";
import useKidListFunctionality from "../../../../customHooks/kidListHook";
import { useHistory } from "react-router-dom";
import WebCategoryRow from "./WebCategoryRow";
import useWebMonitor from "./useWebMonitor";
import { setRuleDataSetUp } from "../../../AxiosRtk/SetRules";
import useSetRules from "../useSetRules";
import { data } from "./dummyData";
import SetRulesDisableSupervison from "../SetRulesDisableSupervison";
import CommonStatus from "../../Common/CommonStatus";
import useDeviceStatus from "../../../../customHooks/deviceStatusProvider";
import useLangTranslation from "../../../../customHooks/languageProvider";
import DeleteChildInfo from "../../modals/DeleteChildInfo";
import { getMyIPAddress } from "../../../AxiosRtk/Miscellaneous";
import { deleteKidAccount } from "../../../AxiosRtk/AddNewChild/ADDNEWCHILDCURD";
import { setSelectedKidId } from "../../../AxiosRtk/DashBoard";
import Select from "react-select";
import useDurationOption from "../../../../customHooks/durationOption";
import { getCategoryStatusValue } from "../../../../../utils/helper";
import KidImage from "../../../../shared/KidImage/KidImage";

const WebCategoryBlock = (props) => {
  
  const history = useHistory();
  const dispatch = useDispatch();
  const [webCategoryData, setWebCategoryData] = useState(null);
  const [showDeletedModal, setShowDeletedModal] = useState(false);
  const [kid, setKid] = useState(null);
  const [device, setDevice] = useState("");
  const [filter, setFilter] = useState("ALL");
  const [filteredData, setFilteredData] = useState();
  const [sortedData, setSortedData] = useState([]);
  const { getLangTranslation } = useLangTranslation();
  const [showModal, setShowModal] = useState(false);
  const [deviceStatus, setDeviceStatus] = useState("");
  const { getDeviceStatusData } = useDeviceStatus(
    deviceStatus,
    setDeviceStatus
  );
  const { categoryOptionsFunction } = useDurationOption();
  const categoryOptions = categoryOptionsFunction();
  const { getImage } = useKidListFunctionality();

  const { handleTimeSupervision } = useSetRules();

  const { kidList, selectedKidId, kidDevicesList } = useSelector(
    ({ dashboard }) => dashboard
  );
  const [loader, setLoader] = useState(false);
  const [reason, setReason] = useState({ value: "", error: "" });

  const { setRulesData } = useSelector(({ setRules }) => setRules);

  const [deviceOptions, setDeviceOptions] = useState([]);


  const { getCollectionData } = useFirebase();

  const {
    handleWebCategoryChange,
    handleAllSelect,
    handleCategoryStatusChange,
  } = useWebMonitor(device, webCategoryData, setWebCategoryData);

  // function handleStatusChangeFilter(e) {

  // }

  function closeModal() {
    setShowModal(false);
  }
  const getPublicIp0 = useCallback(async () => {
    try {
      const { data: ipAddData } = await getMyIPAddress();
      return ipAddData?.ip;
    } catch (error) {
      console.log("Ip0", error);
    }
  }, []);

  async function handleContinue() {
    if (!reason?.value) {
      setReason({
        ...reason,
        error: "Please enter reason",
      });
      return;
    }

    setLoader(true);

    const ip = await getPublicIp0();

    const deleteProfilePayload = {
      kidId: selectedKidId,
      kidName: kid?.childName,
      ipAddress: ip,
      reason: reason?.value,
    };

    deleteKidAccount(deleteProfilePayload)
      .then((res) => {
        closeModal();
        setShowDeletedModal(true);
      })
      .catch((err) => {
        setReason({
          ...reason,
          error: err?.response?.data?.message + ". Redirecting to dashboard.",
        });
        setTimeout(() => {
          window.location.href = "/dashboard";
        }, 2500);
        console.log(
          "child delete catch error ==>>",
          err?.response?.data?.message
        );
      })
      .finally(() => {
        setLoader(false);
        dispatch(setSelectedKidId(kidList[0]?.ID));
      });
  }

  useEffect(() => {
    if (device) {
      getCollectionData(device);
      getDeviceStatusData(device);
    } else {
      dispatch(setRuleDataSetUp(null));
      setDeviceStatus("");
    }
  }, [device]);

  useEffect(() => {
    if (setRulesData) {
      setWebCategoryData(setRulesData?.webmonitoring);
    } else {
      setWebCategoryData(null);
    }
  }, [setRulesData]);

  useEffect(() => {
    if (kidList && selectedKidId) {
      const kid = kidList?.find((item) => item?.ID === selectedKidId);
      setKid(kid);
    }
  }, [kidList, selectedKidId]);

  useEffect(() => {
    if (props) {
      const state = props?.location?.state?.device;
      setDevice(state);
    }
  }, [props]);

  useEffect(() => {
    if (webCategoryData) {
      let webCategories = [...(webCategoryData?.webCategory || [])];
      // let webCategories = [...data?.webCategory]
      if (filter === "ALL") {
        setFilteredData(webCategories);
      } else if (filter === "ALLOW") {
        webCategories = webCategories?.filter(
          (item) => item?.categoryStatus === 0 && item?.blockedByAdmin === 0
        );
      } else if (filter === "BLOCK") {
        webCategories = webCategories?.filter(
          (item) => item?.categoryStatus === 1 || item?.blockedByAdmin === 1
        );
      } else if (filter === "WARN") {
        webCategories = webCategories?.filter(
          (item) => item?.categoryStatus === 2 && item?.blockedByAdmin === 0
        );
      }
      setFilteredData(webCategories);
    }
  }, [webCategoryData, filter]);

  // function handleCategoryStatusChange() {
  const AdminSetRuleLanguageData = useSelector(({ setRules }) => setRules);
  const { appLanguageId } = useSelector(({ misc }) => misc);
  const lang =
    AdminSetRuleLanguageData?.AdminSetRuleLanguageData?.languages?.find(
      (item) => item?.id === appLanguageId
    );

  useEffect(() => {
    setDeviceOptions(
      kidDevicesList?.map((item) => {
        return { value: item?.ID, label: item?.Name };
      })
    );
  }, [kidDevicesList]);

  useEffect(() => {
    const temp = filteredData?.map((item) => {
      return { ...item, blockStatus: getCategoryStatusValue(item) };
    });
    temp?.sort((a, b) => b.blockStatus - a.blockStatus);
    setSortedData(temp);
  }, [filteredData]);

  return (
    <>
      <div className="card mb-6">
        <div className="card-body">
          <div className="inline-list-wrap align-items-center separator space-24">
            <div className="list-item">
              <div className="list-content">
                <div
                  className="d-inline-flex align-items-center lh-1 c-pointer fs-5"
                  onClick={() => history.goBack()}
                >
                  {/* <Link to={history.goBack()} className="text-blue-900 fs-5"> */}
                  <i
                    className={`${
                      lang?.isRTL === 1 ? "icon-arrow-right" : "icon-arrow-left"
                    }`}
                  />
                  {/* </Link> */}
                  <h3 className="text-blue-900 mb-0">
                    {getLangTranslation(
                      "WEB_SUPERVISION_WEB_CATEGORY",
                      "Web categories"
                    )}
                  </h3>
                </div>
              </div>
            </div>
            <div className="list-item">
              {/* <span className="icon-wrap icon-rounded me-2 p-0 overflow-hidden ratio ratio-1x1 border-0">
                <img src={getImage(kid?.image, kid?.gender)} alt="icon" />
              </span> */}
              <KidImage imageUrl={kid?.image} gender={kid?.gender} />
              <div className="list-content">
                <h5 className="text-blue-900 mb-0">{kid?.childName}</h5>
                <CommonStatus status={deviceStatus} />
              </div>
            </div>
            <div className="list-item col-12 col-md-3">
              <div className="select-with-icon">
                <span className="icon-wrap icon-blue pt-cursor border-0">
                  <i className="icon-mobile fs-5" />
                </span>
                {/*  <select
                  className="form-select text-dark single-select-text"
                  value={device || ""}
                  onChange={(e) => setDevice(e.target.value)}
                >
                  <option value="">Select</option>
                  {kidDevicesList?.map((item, index) => {
                    return (
                      <option value={item?.ID} key={index}>
                        {item?.Name}
                      </option>
                    );
                  })}
                </select>*/}
                <Select
                  className="custom-select "
                  classNamePrefix="custom-select"
                  placeholder="Select Device"
                  options={deviceOptions}
                  value={
                    deviceOptions?.find((item) => item?.value == device) || ""
                  }
                  onChange={(val) => {
                    setDevice(val.value);
                  }}
                  isSearchable={false}
                />
              </div>
            </div>
            {/* <span
                            className="form-check form-switch ms-auto align-self-center mb-0"
                        >
                            <label
                                className="form-check-label"
                                htmlFor="deviceTime"
                            >
                                Disable Supervision
                            </label>
                            <input
                                className="form-check-input"
                                id='deviceTime'
                                type="checkbox"
                                role="switch"
                                defaultChecked
                            />
                        </span>
                        <span className="icon-wrap pt-cursor">
                            <i className="icon-setting"></i>
                        </span> */}

            {device && (
              <>
                <SetRulesDisableSupervison
                  enableSupervision={setRulesData?.enableSupervision}
                  handleTimeSupervision={handleTimeSupervision}
                  deviceSelected={device}
                />
                <span className="icon-wrap pt-cursor">
                  {/* <i className="icon-setting"></i> */}
                  <div className="dropdown">
                    <i
                      className="icon-setting  pt-cursor"
                      type="button"
                      id="dropdownMenuButton1"
                      data-bs-toggle="dropdown"
                      aria-expanded="false"
                    />
                    <ul
                      className="dropdown-menu"
                      aria-labelledby="dropdownMenuButton1"
                    >
                      <li
                        className="px-6 pt-cursor fw-semibold d-flex justify-content-between align-items-center gap-1"
                        onClick={() =>
                          history.push("/set-rules/manage-notifications")
                        }
                      >
                        {getLangTranslation(
                          "MANAGE_NOTIFICATIONS",
                          "Manage notifications"
                        )}{" "}
                        <i className="icon-arrow-right" />
                      </li>
                      <li
                        className="px-6 pt-cursor d-flex fw-semibold justify-content-between align-items-center gap-1"
                        onClick={() => history.push("/set-rules/copy-settings")}
                      >
                        {getLangTranslation("COPY_SETTINGS", "Copy settings")}{" "}
                        <i className="icon-arrow-right" />
                      </li>
                      <li
                        className="px-6 pt-cursor d-flex fw-semibold justify-content-between align-items-center gap-1"
                        onClick={() =>
                          history.push("/set-rules/default-settings")
                        }
                      >
                        {getLangTranslation(
                          "SETRULE_LOAD_DEFAULT_SETTINGS",
                          "Load default settings"
                        )}{" "}
                        <i className="icon-arrow-right" />
                      </li>
                      <li
                        className="px-6 pt-cursor d-flex fw-semibold justify-content-between align-items-center gap-1 text-danger"
                        onClick={() => setShowModal(true)}
                      >
                        {getLangTranslation(
                          "SET_RULES_DELETE_CHILD_PROFILE",
                          "Delete child's profile"
                        )?.replace('child', kid?.childName)}{" "}
                        <i className="icon-arrow-right" />
                      </li>
                    </ul>
                  </div>
                </span>
              </>
            )}
            <DeleteChildInfo
              showModal={showModal}
              closeModal={closeModal}
              handleContinue={handleContinue}
              loader={loader}
              reason={reason}
              setReason={setReason}
              getLangTranslation={getLangTranslation}
            />
          </div>
        </div>
      </div>
      <div className="card">
        <div className="card-body">
          <div className="d-flex align-items-center flex-wrap flex-md-nowrap gap-3 mb-6">
            <div className="d-flex align-items-center flex-wrap gap-6">
              <div className="form-check ">
                <input
                  className="form-check-input"
                  id="ALL_SELECT"
                  type="checkbox"
                  name="ALL_SELECT"
                  checked={
                    webCategoryData?.webCategory?.length > 0 &&
                    webCategoryData?.webCategory?.filter(
                      (item) => !item?.isChecked
                    )?.length < 1
                  }
                  onChange={handleAllSelect}
                />
                <label
                  className="form-check-label text-nowrap text-dark"
                  htmlFor="ALL_SELECT"
                >
                  {getLangTranslation(
                    "MANAGE_NOTIFICATION_SELECT_ALL",
                    "Select all"
                  )}
                </label>
              </div>
              <button
                className="btn btn-outline-success d-inline-flex align-items-center gap-1 text-nowrap"
                onClick={() => handleCategoryStatusChange("ALLOW")}
              >
                <i className="icon-check-fill success-icon fs-5" />{" "}
                {getLangTranslation("APP_WEB_CATEGORY_STATUS_ALLOWED", "Allow")}
              </button>
              <button
                className="btn btn-outline-warning d-inline-flex align-items-center gap-1 text-nowrap me-3"
                onClick={() => handleCategoryStatusChange("WARN")}
              >
                <i className="icon-info-triangle-fill warning-icon fs-5" />{" "}
                {getLangTranslation("APP_WEB_CATEGORY_STATUS_WARNED", "Warn")}
              </button>
              <button
                className="btn btn-outline-danger d-inline-flex align-items-center gap-1 text-nowrap me-3"
                onClick={() => handleCategoryStatusChange("BLOCK")}
              >
                <i className="icon-ban danger-icon fs-5" />{" "}
                {getLangTranslation("APP_WEB_CATEGORY_STATUS_BLOCKED", "Block")}
              </button>
            </div>
            <div className="d-flex align-items-center gap-3 justify-content-end flex-fill">
              <Select
                className="custom-select col-lg-4"
                classNamePrefix="custom-select"
                placeholder="Select category"
                options={categoryOptions}
                value={
                  categoryOptions?.find((item) => item?.value == filter) || ""
                }
                onChange={(val) => {
                  setFilter(val.value);
                }}
                isSearchable={false}
              />
            </div>
          </div>
          <div className="table-responsive">
            <table className="table table-striped">
              <thead>
                <tr>
                  <th className="v-middle">
                    <div className="form-check">
                      <label
                        className="form-check-label mt-1"
                        htmlFor="taskName"
                      >
                        {getLangTranslation("WEB_CATEGORY", "Web Category")}
                      </label>
                    </div>
                  </th>
                  <th className="v-middle">
                    {getLangTranslation("DEVICE_DETAIL_ACTION", "Actions")}
                  </th>
                  {/* <th className="v-middle">
                    {getLangTranslation("NOTE", "Note")}
                  </th> */}
                </tr>
              </thead>
              <tbody>
                {sortedData?.map((web) => {
                  return (
                    <WebCategoryRow
                      item={web}
                      key={Math.floor(Math.random() * Math.pow(10, 5))}
                      handleWebCategoryChange={handleWebCategoryChange}
                      getLangTranslation={getLangTranslation}
                    />
                  );
                })}
              </tbody>
            </table>
            {filteredData?.length === 0 && (
              <div className="text-center my-3">
                --- {getLangTranslation("NO_DATA_LOG", "No data found")} ---
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default WebCategoryBlock;
